import enumsModule from '@/pages/_root/modules/enums/enums.module';

// #region Actions
const actions = {
  async createExample({_commit, _dispatch, _state}, {_token}) {
    // ...
  },
};
// #endregion

// #region Getters
const getters = {
  getUserId: (state) => state.userId,
  getRolesArray: (state) => state.roles,
  getDescargarDocumento: (state) => state.descargarDocumento,
  getEmailDiario: (state) => state.emailDiario,
  getPresentar: (state) => state.presentar,
  getUnidadId: (state) => state.unidadId,
  getNivelRootId: (state) => state.nivelRootId,
  getImpersonateUser: (state) => state.impersonateUser,
  getImpersonateUserName: (state) => state.impersonateUserName,
  getthereIsImpersonateUser: (state) => state.impersonateUser,
  getTextSpinner: (state) => state.textSpinner,

  /* Comprueba solo un permiso especifico, debe ser un número
    ejemplo: 1
  */
  getCheckAccess: (_state, getter) => (_requiredRole) => {
    return getter.getRolesArray?.includes(_requiredRole);
  },
  /* Comprueba solo un permiso especifico, debe ser un texto
    ejemplo: 'SuperAdministrador'
  */
  getCheckAccessTexto: (_state, getter) => (_enums, _requiredRole) => {
    return getter.getRolesArray.includes(
      enumsModule.getters.getTiposPermisoByKey(_enums)(_requiredRole),
    );
  },
  /* Comprueba una array de permisos, esta array sera de números
    ejemplo: [1,2]
  */
  getCompareRoles: (_state, getter) => (_requiredRole) => {
    return !getter.getRolesArray.every((_element) => {
      return !(_requiredRole.includes(parseInt(_element)));
    });
  },
  /* Comprueba una array de permisos, esta array sera de textos
    ejemplo: ['SuperAdministrador','Administrador']
  */
  getCompareRolesTextos: (_state, getter) => (_enums, _requiredRole) => {
    return !_requiredRole.every((_element) => {
      return !getter.getCheckAccess(
        enumsModule.getters.getTiposPermisoByKey(_enums)(_element));
    });
  },
};
// #endregion


// #region Mutations
const mutations = {
  setUserId(stateTarget, userId) {
    stateTarget.userId = userId;
  },
  setToken(stateTarget, token) {
    stateTarget.token = token;
  },
  setRoles(stateTarget, roles) {
    stateTarget.roles = roles;
  },
  setDescargarDocumento(stateTarget, descargarDocumento) {
    stateTarget.descargarDocumento = descargarDocumento;
  },
  setEmailDiario(stateTarget, emailDiario) {
    stateTarget.emailDiario = emailDiario;
  },
  setPresentar(stateTarget, presentar) {
    stateTarget.presentar = presentar;
  },
  setUnidadId(stateTarget, unidadId) {
    stateTarget.unidadId = unidadId;
  },
  setNivelRootId(stateTarget, nivelRootId) {
    stateTarget.nivelRootId = nivelRootId;
  },
  setImpersonateUser(stateTarget, impersonateUser) {
    stateTarget.impersonateUser = impersonateUser;
  },
  setImpersonateUserName(stateTarget, impersonateUserName) {
    stateTarget.impersonateUserName = impersonateUserName;
  },
  setSaveDataUser(stateTarget, userConfigData) {
    stateTarget.userId = userConfigData.userId;
    stateTarget.roles = userConfigData.roles;
    stateTarget.descargarDocumento = userConfigData.descargarDocumento;
    stateTarget.emailDiario = userConfigData.emailDiario;
    stateTarget.presentar = userConfigData.presentar;
    stateTarget.unidadId = userConfigData.unidadId;
    stateTarget.nivelRootId = userConfigData.nivelRootId;
    stateTarget.impersonateUser = userConfigData.impersonateUser;
    stateTarget.impersonateUserName = userConfigData.impersonateUserName;
  },
  setTextSpinner(stateTarget, textSpinner) {
    stateTarget.textSpinner = textSpinner;
  },
};
// #endregion

// #region State
const stateAuth = () => {
  return {
    userId: '',
    roles: '',
    descargarDocumento: true,
    emailDiario: false,
    presentar: true,
    unidadId: '',
    nivelRootId: '',
    impersonateUser: '',
    impersonateUserName: '',
    textSpinner: 'Cargando...',
  };
};
// #endregion

// #region Etc
const namespaced = true;
const modules = [];
// #endregion

export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  stateAuth,
};
